export enum PaymentOption {
  Full = 'FULL',
  Instalment = 'INSTALMENT',
  FullOrInstalment = 'FULL_OR_INSTALMENT',
}
